import { getMapStateToSberPayBackButtonProps } from "../components/BackButton/logic/logic";
import { getMapStateToSberPayButtonProps } from "../components/Button/logic/logic";
import { getMapStateToSberPayPhoneInputProps } from "../components/PhoneInput/logic/logic";
import { EPaymentMethod } from "../../../../../../dependencies/getContent/constants";
import { findFirst } from "../../../../../../../utils/arrays";
export var getMapStateToSberPayModalProps = function getMapStateToSberPayModalProps(_ref) {
  var getContent = _ref.getContent,
    submitSberPayPayment = _ref.submitSberPayPayment,
    mapStateToSberPayCaptchaInputProps = _ref.mapStateToSberPayCaptchaInputProps,
    refreshCaptcha = _ref.refreshCaptcha;
  return function (getState, setState) {
    var _findFirst, _findFirst2;
    var state = getState();
    var content = getContent();
    return state.scenario && state.scenario.type === EPaymentMethod.SberPay ? {
      agreementText: content.sberPayPopup.agreement,
      backButtonProps: getMapStateToSberPayBackButtonProps({
        getContent: getContent
      })(getState, setState),
      captchaInputProps: mapStateToSberPayCaptchaInputProps(getState, setState),
      step: state.scenario.step,
      confirmationButtonProps: getMapStateToSberPayButtonProps({
        getContent: getContent,
        submitSberPayPayment: submitSberPayPayment,
        refreshCaptcha: refreshCaptcha
      })(getState, setState),
      phoneInputProps: getMapStateToSberPayPhoneInputProps({
        getContent: getContent,
        submitSberPayPayment: submitSberPayPayment,
        refreshCaptcha: refreshCaptcha
      })(getState, setState),
      titleProps: {
        subTitle: (_findFirst = findFirst([state.scenario.step === 1 && content.sberPayPopup.captcha.subtitle, content.sberPayPopup.subtitle])) !== null && _findFirst !== void 0 ? _findFirst : '',
        title: (_findFirst2 = findFirst([state.scenario.step === 1 && content.sberPayPopup.captcha.title, content.sberPayPopup.title])) !== null && _findFirst2 !== void 0 ? _findFirst2 : ''
      }
    } : undefined;
  };
};